import * as React from 'react';
import autobind from 'autobind-decorator';
import cloneDeep from 'lodash.clonedeep';

import { PlusButton, MinusButton } from '../../../common/buttons';
import i18n from '../../../../R/string/i18n';
import { SearchRoomCondition } from '../../../../models/search/SearchCondition';
import { Colors } from '../../../../shared/styles/StyleConst';

type Props = {
  rooms: SearchRoomCondition[];
  onChange: (rooms: SearchRoomCondition[]) => void;
};

type State = {
  adultNumber: number;
};

const MIN_NUM = 1;
const MAX_NUM = 9;

function getAdultNumber(rooms: SearchRoomCondition[], index: number) {
  if (!rooms[index]) return 0;
  return rooms[index].adults;
}

function isMinusButtonDisabled(rooms: SearchRoomCondition[], index: number) {
  const room = rooms[index];
  if (!room) return false;
  return room.adults <= MIN_NUM;
}

function isPlusButtonDisabled(rooms: SearchRoomCondition[], index: number) {
  const room = rooms[index];
  if (!room) return false;
  return room.adults >= MAX_NUM;
}

export default class AdultInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const { rooms } = props;
    const index = 0;
    this.state = {
      adultNumber: rooms[index].adults,
    };
  }

  @autobind
  onClickMinus(index: number) {
    const rooms = cloneDeep(this.props.rooms);
    if (isMinusButtonDisabled(rooms, index)) return;
    rooms[index].adults -= 1;
    this.props.onChange(rooms);
    const adultNumber = getAdultNumber(rooms, index);
    this.setState({
      adultNumber,
    });
  }

  @autobind
  onClickPlus(index: number) {
    const rooms = cloneDeep(this.props.rooms);
    if (isPlusButtonDisabled(rooms, index)) return;
    rooms[index].adults += 1;
    this.props.onChange(rooms);
    const adultNumber = getAdultNumber(rooms, index);
    this.setState({
      adultNumber,
    });
  }

  render() {
    const { rooms } = this.props;
    const { adultNumber } = this.state;
    // TODO: 複数部屋対応するまで0固定
    const index = 0;
    return (
      <div className="adult-input row align-items-center">
        <div className="adult-title col-4">
          <p>{i18n.webYadoAdult()}</p>
        </div>
        <div className="col-8">
          <div className="d-flex justify-content-end align-items-center">
            <MinusButton
              onClick={() => this.onClickMinus(index)}
              disabled={isMinusButtonDisabled(rooms, index)}
            />
            <div className="number">{adultNumber}</div>
            <PlusButton
              onClick={() => this.onClickPlus(index)}
              disabled={isPlusButtonDisabled(rooms, index)}
            />
          </div>
        </div>
        <style jsx>
          {`
            .adult-input {
              border-bottom: 1px solid #efefef;
              padding: 8px 0;
              width: 100%;
            }
            .adult-input p {
              font-size: 14px;
              font-weight: 500;
              letter-spacing: 2.03px;
              text-align: left;
              color: ${Colors.deepBlack};
              margin-bottom: 0;
            }
            .adult-input .number {
              width: 70px;
              font-size: 14px;
              font-weight: bold;
              letter-spacing: 2.03px;
              text-align: center;
              color: ${Colors.deepBlack};
            }
            .adult-title {
              padding-left: 0;
              white-space: nowrap;
            }
          `}
        </style>
      </div>
    );
  }
}
